// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qeiPv","delete":"styles_delete__kyh0J","update":"styles_update__19xlO","add":"styles_add__2TlAw"};